import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 bg-[#050810] border-t border-gray-900" data-id="element-30">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-31">
          <p className="text-gray-600 text-sm" data-id="element-32">
            © 2026 De Gamer a Creador. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-33">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 text-sm hover:text-[#00d4aa] transition-colors" data-id="element-34">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 text-sm hover:text-[#00d4aa] transition-colors" data-id="element-35">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-36">
          <div className="bg-[#111827] border border-gray-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto shadow-[0_0_40px_rgba(0,212,170,0.1)]" onClick={e => e.stopPropagation()} data-id="element-37">
            {/* Modal Header */}
            <div className="sticky top-0 bg-[#111827] border-b border-gray-800 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-38">
              <h2 className="text-xl font-bold text-white" data-id="element-39">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" aria-label="Cerrar" data-id="element-40">
                <X className="h-5 w-5" data-id="element-41" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="px-6 py-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-42">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-43" /> : <TermsContent data-id="element-44" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-45">Última actualización: Enero 2024</p>

      <h3 className="text-white font-semibold text-base" data-id="element-46">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-47">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos datos de tarjetas de crédito
        directamente; estos son procesados por nuestro proveedor de pagos
        seguro.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-48">
        2. Uso de la Información
      </h3>
      <p data-id="element-49">
        Tu información personal se utiliza exclusivamente para: procesar y
        entregar tu compra, enviarte el enlace de descarga del producto, y
        comunicarnos contigo en caso de ser necesario respecto a tu pedido. No
        vendemos, alquilamos ni compartimos tu información personal con terceros
        con fines de marketing.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-50">
        3. Protección de Datos
      </h3>
      <p data-id="element-51">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Todas las transacciones se realizan a
        través de conexiones cifradas SSL.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-52">4. Cookies</h3>
      <p data-id="element-53">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar algunas
        funcionalidades.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-54">5. Tus Derechos</h3>
      <p data-id="element-55">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, puedes comunicarte con
        nosotros a través de los canales oficiales disponibles.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-56">
        6. Cambios en esta Política
      </h3>
      <p data-id="element-57">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta misma página con
        la fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-58">Última actualización: Enero 2024</p>

      <h3 className="text-white font-semibold text-base" data-id="element-59">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-60">
        Al realizar la compra del producto digital "De Gamer a Creador", aceptas
        estos términos y condiciones en su totalidad. Si no estás de acuerdo con
        alguno de estos términos, te recomendamos no proceder con la compra.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-61">
        2. Producto Digital
      </h3>
      <p data-id="element-62">
        El producto consiste en un paquete de materiales digitales en formato
        PDF que incluye: el eBook principal, la Matriz Gamer-Coder, el Contrato
        de Creador, la Guía de Configuración y el Glosario Gamer para Padres. El
        acceso se entrega de forma instantánea tras confirmar el pago.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-63">3. Licencia de Uso</h3>
      <p data-id="element-64">
        Al adquirir el producto, recibes una licencia personal e intransferible
        para uso familiar. Queda prohibida la reproducción, distribución,
        reventa o compartición del material con terceros fuera de tu núcleo
        familiar.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-65">
        4. Política de Reembolso
      </h3>
      <p data-id="element-66">
        Ofrecemos una garantía de satisfacción de 7 días. Si el producto no
        cumple con tus expectativas, puedes solicitar un reembolso completo
        dentro de los primeros 7 días posteriores a la compra, sin preguntas.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-67">
        5. Limitación de Responsabilidad
      </h3>
      <p data-id="element-68">
        Los resultados pueden variar según la dedicación, edad del niño y otros
        factores individuales. No garantizamos resultados específicos. El
        material es educativo y orientativo, y los padres son responsables de
        supervisar las actividades de sus hijos.
      </p>

      <h3 className="text-white font-semibold text-base" data-id="element-69">
        6. Propiedad Intelectual
      </h3>
      <p data-id="element-70">
        Todo el contenido del producto, incluyendo textos, gráficos, diseños y
        metodologías, está protegido por derechos de autor. Queda prohibida
        cualquier reproducción no autorizada.
      </p>
    </>;
}